import * as actionTypes from './actionType';
import join from 'url-join';
import { ApiServerUrl } from '../../config.json';
import {
    Base_Prescription_Err,
    Base_Retainer_Request_Err,
    Base_Smile_Design_Prescription_Err,
    buildSmileDesignPrescriptionErr,
} from './utils';
import { initRetainerReqFormValue } from '../DiffRetainers/reducer';
import _ from 'lodash';
export const BASE_RESTORATIVE_OPTIONS = {
    value: 'No',
    subValue: {
        value: '',
        onlayPosition: [],
        verticalDimension: {
            verticalDimensionUpperPosterior: '',
            verticalDimensionLowerPosterior: '',
        },
    },
};

export const BASE_PRE_IMPLANT_ALIGNMENT = {
    value: 'No',
    prostheticSpace: [],
};

export const ray_photo_mapping = {
    jaw_side_with_smile: 'photo0',
    face_front_with_smile: 'photo1',
    teeth_side_without_smile: 'photo2',
    jaw_front_with_smile: 'photo3',
    teeth_side_with_smile: 'photo4',
    jaw_side_without_smile: 'photo5',
    face_side_with_smile: 'photo6',
    teeth_front_with_smile: 'photo7',
    face_side_without_smile: 'photo8',
    free_angle_one: 'photo9',
    free_angle_two: 'photo10',
    big_smile_full_face_with_full_retractors: 'photo11',
    front_with_smile: 'radio0',
    side_with_smile: 'radio1',
    cbct: 'radio2',
    impression_upper: 'stl_file0',
    impression_lower: 'stl_file1',
    impression_scan_one: 'stl_file2',
    impression_scan_two: 'stl_file3',
};

export const initialState = {
    enableRaySelectChoose3dFile: false,
    caseRfsId: 0,
    isRayCase: 0,
    facialScan: { data: null, dataURL: null, name: '' },
    promotionCode: '',
    gender: 'M',
    lastName: '',
    firstName: '',
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getYear() + 1870,
    remarks: '',
    dr_remark: '',
    internalRemarks: '',
    refCode: null,
    patientPhoto: { id: 'profile_pic', uploaded: false, dataURL: null, data: null, rotate: 0 },
    clinical_cond: '',
    extraction: 'none',
    expansion: 'none',
    extractionConcat: '',
    expansionConcat: '',
    interproximalReduction: 'clinicalSimulation',
    distalization: 'clinicalSimulation',
    proclination: 'clinicalSimulation',
    treatmentSimulation: 'primary',
    overJet: 'clinicalSimulation',
    overBite: 'clinicalSimulation',
    midLine: [],
    crossBite: 'clinicalSimulation',
    comment: '',
    clinicalConditionComment: '',
    teeth: [
        { name: 't1.png', checked: false },
        { name: 't2.png', checked: false },
        { name: 't3.png', checked: false },
        { name: 't4.png', checked: false },
        { name: 't5.png', checked: false },
        { name: 't6.png', checked: false },
        { name: 't7.png', checked: false },
        { name: 't8.png', checked: false },
        { name: 't9.png', checked: false },
        { name: 't10.png', checked: false },
        { name: 't11.png', checked: false },
        { name: 't12.png', checked: false },
        { name: 't13.png', checked: false },
        { name: 't14.png', checked: false },
        { name: 't15.png', checked: false },
        { name: 't16.png', checked: false },
        { name: 't17.png', checked: false },
        { name: 't18.png', checked: false },
        { name: 't19.png', checked: false },
        { name: 't20.png', checked: false },
        { name: 't21.png', checked: false },
        { name: 't22.png', checked: false },
        { name: 't23.png', checked: false },
        { name: 't24.png', checked: false },
        { name: 't25.png', checked: false },
        { name: 't26.png', checked: false },
        { name: 't27.png', checked: false },
        { name: 't28.png', checked: false },
        { name: 't29.png', checked: false },
        { name: 't30.png', checked: false },
        { name: 't31.png', checked: false },
        { name: 't31.png', checked: false },
    ],

    files: [
        {
            id: 'jaw_side_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'face_front_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'teeth_side_without_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'jaw_front_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'teeth_side_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'jaw_side_without_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'face_side_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'teeth_front_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'face_side_without_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },

        {
            id: 'free_angle_one',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'free_angle_two',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'big_smile_full_face_with_full_retractors',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'photo',
            upload_later: false,
            will_not_upload: null,
        },

        {
            id: 'front_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'radio',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'side_with_smile',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'radio',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'cbct',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'radio',
            upload_later: false,
            will_not_upload: null,
        },
        {
            id: 'impression_upper',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'stl_file',
            upload_later: false,
            will_not_upload: null,
            platform: '',
        },
        {
            id: 'impression_lower',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'stl_file',
            upload_later: false,
            will_not_upload: null,
            platform: '',
        },
        {
            id: 'impression_scan_one',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'stl_file',
            upload_later: false,
            will_not_upload: null,
            platform: '',
        },
        {
            id: 'impression_scan_two',
            uploaded: false,
            dataURL: null,
            data: null,
            flipped: false,
            rotate: 0,
            category: 'stl_file',
            upload_later: false,
            will_not_upload: null,
            platform: '',
        },
    ],
    cbctFiles: [],
    impressionType: 'FILE',
    scannerBrand: '',
    doctorId: '',
    modernCode: '',
    waybillNumber: '',
    courierCompany: '',
    saveSuccess: false,
    errors: [
        { id: 'patient_info', msg: 'First Name And Last Name Is Required', valid: false },
        { id: 'photo', msg: 'Please Upload All The mandatory Photos', valid: false },
        { id: 'radiograph', msg: 'Please Upload The Mandatory Radiograph Image', valid: false },
        {
            id: 'impression',
            msg: "Please Upload All Necessary STL Files or Check 'Upload this photo later' Boxes",
            valid: false,
        },
        Base_Retainer_Request_Err,
        Base_Prescription_Err,
        Base_Smile_Design_Prescription_Err,
    ],
    ray_draft_changed: [],
    attachment: [], //retrack attachment
    teethIncludedGap: [], // retrack teethGap  (Previous developer used in this reducer for retrack. In fact, this is not suitable cos that's for new patient form, not for retrack)
    case_type_id: null,
    archToTreat: null,
    archToTreatUpperStep: undefined,
    archToTreatLowerStep: undefined,
    notToTreat1: [],
    attachments1: {
        value: 'placeAttachmentsAsNeeded',
        doNotPlace: [],
        place: [],
        delay: {
            value: 'noDelay',
            stage: '',
        },
    },
    alignersMarginPlacement1: 'coverageExtending',
    anteriorPosteriorRelationship1: {
        r: null,
        l: null,
    },
    spacingAndCrowding1: {
        spacing: {
            value: null,
            location: '',
        },
        crowding: {
            resolveUpper: {
                expand: {
                    value: 'none',
                    teeth: '',
                },
                procline: {
                    value: 'none',
                    teeth: '',
                },
                IPRAnterior: {
                    value: 'none',
                    teeth: '',
                },
                IPRPosteriorRight: {
                    value: 'none',
                    teeth: '',
                },
                IPRPosteriorLeft: {
                    value: 'none',
                    teeth: '',
                },
                extraction: {
                    value: 'none',
                    teeth: '',
                },
            },
            resolveLower: {
                expand: {
                    value: 'none',
                    teeth: '',
                },
                procline: {
                    value: 'none',
                    teeth: '',
                },
                IPRAnterior: {
                    value: 'none',
                    teeth: '',
                },
                IPRPosteriorRight: {
                    value: 'none',
                    teeth: '',
                },
                IPRPosteriorLeft: {
                    value: 'none',
                    teeth: '',
                },
                extraction: {
                    value: 'none',
                    teeth: '',
                },
            },
        },
    },
    overJet1: {
        value: 'maintainInitialOverjet',
        subValue: null,
    },
    openbite1: {
        value: 'maintainInitialOpenbite',
        subValue: {
            value: null,
            extrudeAnteriorTeeth: {
                value: false,
                upper: false,
                lower: false,
            },
            intrudePosteriorTeeth: {
                value: false,
                upper: false,
                lower: false,
            },
            placeMiniImplantsTAD: {
                value: false,
                input: '',
            },
        },
    },
    deepBite1: {
        value: 'maintainExistingDeepBite',
        subValue: {
            value: null,
            intrudeAnteriorTeeth: {
                value: false,
                upper: false,
                lower: false,
            },
            extrudePosteriorTeeth: {
                value: false,
                upper: false,
                lower: false,
            },
            placeMiniImplantsTAD: {
                value: false,
                input: '',
            },
        },
    },
    midline1: {
        value: 'maintainInitialMidline',
        subValue: {
            value: null,
            upper: {
                checked: false,
                value: null,
            },
            lower: {
                checked: false,
                value: null,
            },
        },
    },
    posteriorCrossbite1: {
        value: 'maintainInitialCrossbite',
        subValue: {
            value: null,
            subValue: {
                value: null,
                buttonPressedDirectlyOnAligner: {
                    maxillaryTeeth: false,
                    mandibularTeeth: false,
                },
                cutoutToBondButtonDirectlyOnTeeth: {
                    maxillaryTeeth: false,
                    mandibularTeeth: false,
                },
                otherMethod: '',
            },
        },
    },
    cuttingOptions1: 'gingivalCutting',
    auxiliaries1: {
        classIIElastics: null,
        classIIIElastics: null,
        subValue: {
            upper: {
                value: 'upperCutout',
            },
            lower: {
                value: 'lowerCutout',
            },
        },
        otherElastics: {
            value: 'No',
            comment: '',
        },
    },
    trioDimForce: 'true',
    restorativeOptions: _.cloneDeep(BASE_RESTORATIVE_OPTIONS),
    preImplantAligment: _.cloneDeep(BASE_PRE_IMPLANT_ALIGNMENT),
    addOnSmileDesign: {
        value: 'No',
    },
    upSellSmileDesignPrescriptionFormData: {},
    upSellSmileDesignPrescriptionFormIsValid: false,
    orderTriobleachOption1: 'No',
    specialInstructions1: '',
    prescriptionError: '',
    prescriptionErrorQuestion: 0,
    prescriptionScrollToId: '',
    prescriptionScroll: false,
    visitedTabs: [],

    // retainerRequestPrescriptionNote: null
    retainerRequestPrescriptionNote: initRetainerReqFormValue,
};
const initialStateBackup = JSON.parse(JSON.stringify(initialState));

const reducer = (state = initialState, action) => {
    let ray_draft_changed = state.ray_draft_changed;
    switch (action.type) {
        case actionTypes.NEW_PATIENT_INFO_CHANGE_TP_OPTS:
            return {
                ...state,
                case_type_id: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_PROMO:
            return {
                ...state,
                promotionCode: action.value,
            };
        case actionTypes.NEW_PATIENT_DELIVERY_ADDRESS:
            return {
                ...state,
                address: action.value,
            };
        case actionTypes.NEW_PATIENT_INFO_GENDER:
            return {
                ...state,
                gender: action.value,
            };
        case actionTypes.NEW_PATIENT_INFO_LASTNAME:
            return {
                ...state,
                lastName: action.value,
            };
        case actionTypes.NEW_PATIENT_INFO_FIRSTNAME:
            return {
                ...state,
                firstName: action.value,
            };

        case actionTypes.NEW_PATIENT_INFO_DAY:
            return {
                ...state,
                day: action.value,
            };

        case actionTypes.NEW_PATIENT_INFO_MONTH:
            return {
                ...state,
                month: action.value,
            };

        case actionTypes.NEW_PATIENT_INFO_YEAR:
            return {
                ...state,
                year: action.value,
            };
        case actionTypes.NEW_PATIENT_INFO_REFERENCE_CODE:
            return {
                ...state,
                refCode: action.value,
            };
        case actionTypes.NEW_PATIENT_INFO_REMARK:
            return {
                ...state,
                remarks: (action.value ?? '').slice(0, 1000),
            };

        case actionTypes.NEW_PATIENT_INTERNAL_REMARK:
            return {
                ...state,
                internalRemarks: action.value.slice(0, 1000),
            };

        case actionTypes.NEW_PATIENT_DR_REMARK:
            return {
                ...state,
                dr_remark: (action.value ?? '').slice(0, 1000),
            };

        case actionTypes.NEW_PATIENT_INFO_PHOTO:
            if (state.patientPhoto.dataURL) {
                URL.revokeObjectURL(state.patientPhoto.dataURL);
                state.patientPhoto.dataURL = null;
            }
            return {
                ...state,
                patientPhoto: {
                    ...state.patientPhoto,
                    data: action.value,
                    dataURL: action.value && URL.createObjectURL(action.value),
                    uploaded: true,
                    rotate: 0,
                },
            };
        case actionTypes.NEW_PATIENT_INFO_PHOTO_ROTATE:
            let newRotatePhoto = { ...state.patientPhoto };
            newRotatePhoto['rotate'] = action.value;
            return {
                ...state,
                patientPhoto: newRotatePhoto,
            };
        case actionTypes.NEW_PATIENT_CLINICAL_CONDITION_COMMENT:
            return {
                ...state,
                clinicalConditionComment: action.value.slice(0, 1000),
            };
        case actionTypes.CHANGE_CLINICAL_CONDITION:
            return {
                ...state,
                clinical_cond: action.value,
            };
        case actionTypes.NEW_PATIENT_QUES_EXTRACTION:
            return {
                ...state,
                extraction: action.value,
            };

        case actionTypes.NEW_PATIENT_QUES_EXPANSION:
            return {
                ...state,
                expansion: action.value,
            };
        case actionTypes.NEW_PATIENT_QUES_EXTRACTION_CONCAT:
            return {
                ...state,
                extractionConcat: action.value,
            };

        case actionTypes.NEW_PATIENT_QUES_EXPANSION_CONCAT:
            return {
                ...state,
                expansionConcat: action.value,
            };
        case actionTypes.NEW_PATIENT_QUES_INTER:
            return {
                ...state,
                interproximalReduction: action.value,
            };

        case actionTypes.NEW_PATIENT_QUES_DIST:
            return {
                ...state,
                distalization: action.value,
            };

        case actionTypes.NEW_PATIENT_QUES_PROCLINATION:
            return {
                ...state,
                proclination: action.value,
            };

        case actionTypes.NEW_PATIENT_QUES_SIMULTAE:
            return {
                ...state,
                treatmentSimulation: action.value,
            };
        case actionTypes.NEW_PATIENT_QUES_JET:
            return {
                ...state,
                overJet: action.value,
            };

        case actionTypes.NEW_PATIENT_QUES_BITE:
            return {
                ...state,
                overBite: action.value,
            };
        case actionTypes.NEW_PATIENT_QUES_MID:
            return {
                ...state,
                midLine: state.midLine.includes(action.value)
                    ? state.midLine.filter((v) => v !== action.value)
                    : [...state.midLine, action.value],
            };
        case actionTypes.NEW_PATIENT_QUES_ACROSS:
            return {
                ...state,
                crossBite: action.value,
            };
        case actionTypes.NEW_PATIENT_QUES_TEETH:
            let modify_teeth_images = [...state.teeth];
            modify_teeth_images[action.value[0]].checked = action.value[1]
                ? true
                : !modify_teeth_images[action.value[0]].checked;
            return {
                ...state,
                teeth: modify_teeth_images,
            };
        case actionTypes.NEW_PATIENT_QUES_COMMENT:
            return {
                ...state,
                comment: action.value.slice(0, 1000),
            };
        case actionTypes.NEW_PATIENT_IMPRESSION_TYPE:
            return {
                ...state,
                impressionType: action.value,
            };
        case actionTypes.NEW_PATIENT_MODERN_CODE:
            return {
                ...state,
                modernCode: action.value,
            };
        case actionTypes.NEW_PATIENT_SCANNER:
            return {
                ...state,
                scannerBrand: action.value,
            };
        case actionTypes.NEW_PATIENT_DOCTOR:
            return {
                ...state,
                doctorId: action.value,
            };
        case actionTypes.NEW_PATIENT_COURIER_COMPANY:
            return {
                ...state,
                courierCompany: action.value,
            };
        case actionTypes.NEW_PATIENT_WAYBILL_NUMBER:
            return {
                ...state,
                waybillNumber: action.value,
            };
        case actionTypes.NEW_PATIENT_CBCT:
            let cbct = [...state.cbctFiles];
            cbct.push({ path: action.value, name: action.name });
            return {
                ...state,
                cbctFiles: cbct,
            };
        case actionTypes.NEW_PATIENT_REMOVE_CBCT:
            let newcbctFile = [...state.cbctFiles];
            let modifiedFile = newcbctFile.splice(action.value, 1);
            return {
                ...state,
                cbctFiles: newcbctFile,
            };
        case actionTypes.NEW_PATIENT_FILES: {
            let files = state.files.map((imageObj) => {
                if (imageObj.id == action.id) {
                    if (imageObj?.dataURL) {
                        URL.revokeObjectURL(imageObj.dataURL);
                        imageObj.dataURL = null;
                    }
                    if (action.value == 'upload_later') {
                        imageObj['data'] = null;
                        imageObj['dataURL'] = null;
                        imageObj['rotate'] = 0;
                        imageObj['flipped'] = false;
                        imageObj['uploaded'] = false;
                        imageObj['upload_later'] = !imageObj['upload_later'];
                        imageObj['will_not_upload'] = false;
                    } else if (action.value == 'will_not_upload') {
                        imageObj['data'] = null;
                        imageObj['dataURL'] = null;
                        imageObj['rotate'] = 0;
                        imageObj['flipped'] = false;
                        imageObj['upload_later'] = false;
                        imageObj['will_not_upload'] = !imageObj['will_not_upload'];
                        imageObj['upload_later'] = false;
                    } else if (action.value == 'remove') {
                        imageObj['data'] = null;
                        imageObj['dataURL'] = null;
                        imageObj['rotate'] = 0;
                        imageObj['flipped'] = false;
                        imageObj['uploaded'] = false;
                        imageObj['will_not_upload'] = false;
                        imageObj['upload_later'] = false;
                    } else {
                        imageObj['rotate'] = 0;
                        imageObj['flipped'] = false;
                        imageObj['data'] = action.value;
                        imageObj['dataURL'] = action.value;
                        imageObj['uploaded'] = true;
                        imageObj['upload_later'] = false;
                        imageObj['will_not_upload'] = false;
                        imageObj['platform'] = action.platform || undefined;
                    }
                    if (
                        typeof imageObj?.data === 'object' &&
                        imageObj?.data !== null &&
                        imageObj.category !== 'stl_file'
                    ) {
                        try {
                            imageObj.dataURL = URL.createObjectURL(imageObj.data);
                        } catch {
                            imageObj.data = null;
                            imageObj.dataURL = null;
                        }
                    }
                }
                return imageObj;
            });
            let field_name = Object.keys(ray_photo_mapping).includes(action.id)
                ? ray_photo_mapping[action.id]
                : undefined;
            if (field_name && !ray_draft_changed.includes(field_name)) {
                ray_draft_changed.push(field_name);
            }

            return {
                ...state,
                files,
                ray_draft_changed,
            };
        }
        case actionTypes.NEW_PATIENT_FACIAL_SCAN: {
            if (state.facialScan.dataURL && typeof state.facialScan.data === 'object') {
                URL.revokeObjectURL(state.facialScan.dataURL);
            }
            if (action.value === 'remove') {
                return {
                    ...state,
                    facialScan: { data: null, dataURL: null, name: '' },
                };
            }
            return {
                ...state,
                facialScan: {
                    data: action.value,
                    dataURL: URL.createObjectURL(action.value),
                    name: action.value.name,
                },
            };
        }
        // p: shortcut skipping "Terrible" callback function linked list
        case actionTypes.NEW_PATIENT_FILE_SHORTCUT:
            return {
                ...state,
                files: state.files.map((file) => {
                    if (file.id == action.id) {
                        if (file.dataURL) {
                            URL.revokeObjectURL(file.dataURL);
                            file.dataURL = null;
                        }
                        switch (action.subtype) {
                            case 'upload_later': {
                                file = {
                                    ...file,
                                    data: null,
                                    uploaded: false,
                                    upload_later: action.value,
                                };
                                break;
                            }
                            case 'will_not_upload': {
                                file = {
                                    ...file,
                                    data: null,
                                    upload_later: false,
                                    will_not_upload: !action.value,
                                };
                                break;
                            }
                            case 'remove': {
                                file = {
                                    ...file,
                                    data: null,
                                    uploaded: false,
                                    upload_later: false,
                                    will_not_upload: false,
                                };
                                break;
                            }
                            case 'upload': {
                                file = {
                                    ...file,
                                    data: action.value,
                                    uploaded: true,
                                    upload_later: false,
                                    will_not_upload: false,
                                };
                                break;
                            }
                        }
                        if (typeof file?.data === 'object' && file.category !== 'stl_file') {
                            file.dataURL = URL.createObjectURL(file.data);
                        }
                    }
                    return file;
                }),
            };
        case actionTypes.NEW_PATIENT_FILE_INVERT:
            let invertFiles = [...state.files];
            let invertModifiedFiles = invertFiles.filter((imageObj) => {
                if (imageObj.id == action.id) {
                    imageObj['flipped'] = action.value;
                }
            });
            let field_name = Object.keys(ray_photo_mapping).includes(action.id)
                ? ray_photo_mapping[action.id]
                : undefined;
            if (field_name && !ray_draft_changed.includes(field_name)) {
                ray_draft_changed.push(field_name);
            }
            return {
                ...state,
                files: invertFiles,
                ray_draft_changed,
            };
        case actionTypes.NEW_PATIENT_DATA_SAVE_SUCCESS:
            return {
                ...state,
                saveSuccess: true,
            };
        case actionTypes.NEW_PATIENT_DATA_ERROR:
            let errorList = [...state.errors];
            if (!errorList.some((e) => e.id === action.errorMsg.id) && action.errorMsg.msg !== '') {
                errorList.push(action.errorMsg);
            }

            errorList.forEach((v) => {
                if (v.id == action.errorMsg.id) {
                    v['valid'] = action.errorMsg.valid;
                    v['msg'] = action.errorMsg.msg;
                }
            });
            return {
                ...state,
                errors: errorList,
            };
        case actionTypes.NEW_PATIENT_INIT_TEMP:
            if (state.patientPhoto.dataURL) {
                URL.revokeObjectURL(state.patientPhoto.dataURL);
            }
            state.files.forEach((file) => {
                if (file.dataURL) {
                    URL.revokeObjectURL(state.patientPhoto.dataURL);
                }
            });
            return {
                ...JSON.parse(JSON.stringify(initialStateBackup)),
            };
        case actionTypes.NEW_PATIENT_TEMP_SAVE_SUCCESS:
            if (state.patientPhoto.dataURL) {
                URL.revokeObjectURL(state.patientPhoto.dataURL);
            }
            state.files.forEach((file) => {
                if (file.dataURL) {
                    URL.revokeObjectURL(state.patientPhoto.dataURL);
                }
            });
            return {
                ...JSON.parse(JSON.stringify(initialStateBackup)),
                ...action.payload,
            };
        case actionTypes.NEW_PATIENT_FILE_ROTATE: {
            let files = state.files.map((imageObj) => {
                if (imageObj.id == action.id) {
                    imageObj['rotate'] = action.value;
                }
                return imageObj;
            });
            let field_name = Object.keys(ray_photo_mapping).includes(action.id)
                ? ray_photo_mapping[action.id]
                : undefined;
            if (field_name && !ray_draft_changed.includes(field_name)) {
                ray_draft_changed.push(field_name);
            }
            return {
                ...state,
                files,
                ray_draft_changed,
            };
        }
        case actionTypes.NEW_PATIENT_3dFILE_CHOOSED: {
            return {
                ...state,
                caseRfsId: action.value,
            };
        }
        case actionTypes.NEW_PATIENT_ENABLE_RAY_CHOOSE_3dFILE: {
            return {
                ...state,
                enableRaySelectChoose3dFile: action.value,
                isRayCase: action.value ? 1 : 0,
            };
        }
        case actionTypes.NEW_PATIENT_FILE_CHOOSE: {
            let chosenDraftFile = 0;
            let files = action.currentFile.map((imageObj, index) => {
                if (index < 14) {
                    imageObj['data'] = null;
                    imageObj['rotate'] = 0;
                    imageObj['flipped'] = false;
                    imageObj['uploaded'] = false;
                    imageObj['will_not_upload'] = false;
                    imageObj['upload_later'] = false;
                    imageObj['dataURL'] = null;
                }
                return imageObj;
            });
            let patientPhoto = state.patientPhoto;

            if (action.draftFile) {
                chosenDraftFile = action.draftFile.doctor_app_file_id;
                state.draftFileList.map((v) => {
                    if (v.doctor_app_file_id == action.draftFile.doctor_app_file_id) {
                        for (let i = 0; i < 14; i++) {
                            let col = ray_photo_mapping[files[i]['id']];
                            if (col && v[col]) {
                                files[i]['data'] = /^https?:\/\//.test(v[col]) ? v[col] : join(ApiServerUrl, v[col]);
                                files[i]['dataURL'] = /^https?:\/\//.test(v[col]) ? v[col] : join(ApiServerUrl, v[col]);
                                files[i]['uploaded'] = true;
                                if (!ray_draft_changed.includes(col)) {
                                    ray_draft_changed.push(col);
                                }
                            }
                        }
                        // if (!patientPhoto.data) {
                        patientPhoto.data = files[1]['data'];
                        patientPhoto.dataURL = files[1]['dataURL'];
                        patientPhoto.uploaded = true;
                        // }
                    }
                });
            }
            return {
                ...state,
                files,
                chosenDraftFile,
                patientPhoto,
                ray_draft_changed,
            };
        }
        case actionTypes.NEW_PATIENT_INIT_DRAFT_FILE: {
            return {
                ...state,
                draftFileList: action.draftFileList,
                chosenDraftFile: action.chosenDraftFile,
            };
        }
        case actionTypes.NEW_PATIENT_PRES_ARCH_TO_TREAT:
            // console.log(" vv =>",  action.value)
            return {
                ...state,
                archToTreat: action.value,
                archToTreatUpperStep: undefined,
                archToTreatLowerStep: undefined,
            };
        case actionTypes.NEW_PATIENT_PRES_ARCH_PAT_STEP:
            return {
                ...state,
                [action.field]: action.value,
            };
        case actionTypes.NEW_PATIENT_RETRACK_ATTACHMENT:
            if (state.attachment.includes(action.value))
                return {
                    ...state,
                    attachment: [...state.attachment].filter((number) => {
                        return number !== action.value;
                    }),
                };
            return {
                ...state,
                attachment: [...state.attachment, action.value],
            };
        case actionTypes.NEW_PATIENT_TEETH_INCLUDED_GAP:
            if (state.teethIncludedGap.includes(action.value))
                return {
                    ...state,
                    teethIncludedGap: [...state.teethIncludedGap].filter((number) => {
                        return number !== action.value;
                    }),
                };
            return {
                ...state,
                teethIncludedGap: [...state.teethIncludedGap, action.value],
            };
        case actionTypes.NEW_PATIENT_PRES_NOT_TO_TREAT:
            if (state.notToTreat1.includes(action.value))
                return {
                    ...state,
                    notToTreat1: [...state.notToTreat1].filter((number) => {
                        return number !== action.value;
                    }),
                };
            return {
                ...state,
                notToTreat1: [...state.notToTreat1, action.value],
            };
        case actionTypes.NEW_PATIENT_PRES_ATTACHMENTS:
            return {
                ...state,
                attachments1: {
                    ...state.attachments1,
                    value: action.value,
                    doNotPlace: [],
                    place: [],
                },
            };

        case actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_PLACE:
            if (state.attachments1.place.includes(action.value))
                return {
                    ...state,
                    attachments1: {
                        ...state.attachments1,
                        place: [...state.attachments1.place].filter((number) => {
                            return number !== action.value;
                        }),
                    },
                };
            return {
                ...state,
                attachments1: {
                    ...state.attachments1,
                    place: [...state.attachments1.place, action.value],
                },
            };
        case actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_NOT_PLACE:
            if (state.attachments1.doNotPlace.includes(action.value))
                return {
                    ...state,
                    attachments1: {
                        ...state.attachments1,
                        doNotPlace: [...state.attachments1.doNotPlace].filter((number) => {
                            return number !== action.value;
                        }),
                    },
                };
            return {
                ...state,
                attachments1: {
                    ...state.attachments1,
                    doNotPlace: [...state.attachments1.doNotPlace, action.value],
                },
            };
        case actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_DELAY:
            return {
                ...state,
                attachments1: {
                    ...state.attachments1,
                    delay: {
                        ...initialState.attachments1.delay,
                        value: action.value,
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_ATTACHMENTS_DELAY_STAGE:
            return {
                ...state,
                attachments1: {
                    ...state.attachments1,
                    delay: {
                        ...state.attachments1.delay,
                        stage: action.value,
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_MARGIN_PLACEMENT:
            return {
                ...state,
                alignersMarginPlacement1: action.value,
            };
        case actionTypes.NEW_PATIENT_PRES_AP_RELATIONSHIPS:
            return {
                ...state,
                anteriorPosteriorRelationship1: {
                    ...state.anteriorPosteriorRelationship1,
                    [action.field]: action.value,
                },
            };
        case actionTypes.NEW_PATIENT_PRES_SPACING:
            return {
                ...state,
                spacingAndCrowding1: {
                    ...state.spacingAndCrowding1,
                    spacing: {
                        ...initialState.spacingAndCrowding1.spacing,
                        value: action.value,
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_SPACING_LOCATION:
            return {
                ...state,
                spacingAndCrowding1: {
                    ...state.spacingAndCrowding1,
                    spacing: {
                        ...state.spacingAndCrowding1.spacing,
                        location: action.value,
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_CROWDING:
            return {
                ...state,
                spacingAndCrowding1: {
                    ...state.spacingAndCrowding1,
                    crowding: {
                        ...state.spacingAndCrowding1.crowding,
                        [action.category]: {
                            ...state.spacingAndCrowding1.crowding[action.category],
                            [action.field]: {
                                value: action.value,
                                teeth: '',
                            },
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_CROWDING_TEETH: {
            return {
                ...state,
                spacingAndCrowding1: {
                    ...state.spacingAndCrowding1,
                    crowding: {
                        ...state.spacingAndCrowding1.crowding,
                        [action.category]: {
                            ...state.spacingAndCrowding1.crowding[action.category],
                            [action.field]: {
                                ...state.spacingAndCrowding1.crowding[action.category][action.field],
                                teeth: action.value,
                            },
                        },
                    },
                },
            };
        }
        case actionTypes.NEW_PATIENT_PRES_OVERJET:
            if (action.value === 'maintainInitialOverjet' && action.field === 'value') {
                return {
                    ...state,
                    overJet1: initialState.overJet1,
                };
            }
            if (action.value === 'improveResultingOverjetBy' && action.field === 'value') {
                return {
                    ...state,
                    overJet1: {
                        value: 'improveResultingOverjetBy',
                        subValue: 'noPreferenceShowResultsInSimulator',
                    },
                };
            }
            return {
                ...state,
                overJet1: {
                    ...state.overJet1,
                    [action.field]: action.value,
                },
            };
        case actionTypes.NEW_PATIENT_PRES_OPEN_BITE:
            if (action.value === 'maintainInitialOpenbite') {
                return {
                    ...state,
                    openbite1: initialState.openbite1,
                };
            }
            return {
                ...state,
                openbite1: {
                    value: 'improveResultingOpenbiteBy',
                    subValue: {
                        value: 'noPreferenceShowResultsInSimulator',
                        extrudeAnteriorTeeth: {
                            value: false,
                            upper: false,
                            lower: false,
                        },
                        intrudePosteriorTeeth: {
                            value: false,
                            upper: false,
                            lower: false,
                        },
                        placeMiniImplantsTAD: {
                            value: false,
                            input: '',
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_OPEN_BITE_IMPROVE: {
            return {
                ...state,
                openbite1: {
                    ...state.openbite1,
                    subValue: {
                        ...initialState.openbite1.subValue,
                        value: action.value,
                    },
                },
            };
        }
        case actionTypes.NEW_PATIENT_PRES_OPEN_BITE_CHECKBOX: {
            if (action.category) {
                return {
                    ...state,
                    openbite1: {
                        ...state.openbite1,
                        subValue: {
                            ...state.openbite1.subValue,
                            value: null,
                            [action.category]: {
                                ...state.openbite1.subValue[action.category],
                                [action.field]: !state.openbite1.subValue[action.category][action.field],
                            },
                        },
                    },
                };
            } else if (!state.openbite1.subValue[action.field].value) {
                return {
                    ...state,
                    openbite1: {
                        ...state.openbite1,
                        subValue: {
                            ...state.openbite1.subValue,
                            value: null,
                            [action.field]: {
                                ...state.openbite1.subValue[action.field],
                                value: !state.openbite1.subValue[action.field].value,
                            },
                        },
                    },
                };
            } else {
                let copy = JSON.parse(JSON.stringify({ ...state.openbite1.subValue }));
                copy[action.field].value = false;
                if (
                    !copy.extrudeAnteriorTeeth.value &&
                    !copy.intrudePosteriorTeeth.value &&
                    !copy.placeMiniImplantsTAD.value
                ) {
                    return {
                        ...state,
                        openbite1: {
                            ...state.openbite1,
                            subValue: {
                                value: 'noPreferenceShowResultsInSimulator',
                                extrudeAnteriorTeeth: {
                                    lower: false,
                                    upper: false,
                                    value: false,
                                },
                                intrudePosteriorTeeth: {
                                    lower: false,
                                    upper: false,
                                    value: false,
                                },
                                placeMiniImplantsTAD: {
                                    input: '',
                                    value: false,
                                },
                            },
                        },
                    };
                }
                return {
                    ...state,
                    openbite1: {
                        ...state.openbite1,
                        subValue: {
                            ...state.openbite1.subValue,
                            value: null,
                            [action.field]: {
                                ...initialState.openbite1.subValue[action.field],
                                value: !state.openbite1.subValue[action.field].value,
                            },
                        },
                    },
                };
            }
        }
        case actionTypes.NEW_PATIENT_PRES_OPEN_BITE_TEXT:
            return {
                ...state,
                openbite1: {
                    ...state.openbite1,
                    subValue: {
                        ...state.openbite1.subValue,
                        placeMiniImplantsTAD: {
                            ...state.openbite1.subValue.placeMiniImplantsTAD,
                            input: action.value,
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_DEEP_BITE:
            if (action.value === 'maintainExistingDeepBite') {
                return {
                    ...state,
                    deepBite1: initialState.deepBite1,
                };
            }
            return {
                ...state,
                deepBite1: {
                    value: 'improveResultingDeepBiteBy',
                    subValue: {
                        value: 'noPreference',
                        intrudeAnteriorTeeth: {
                            value: false,
                            upper: false,
                            lower: false,
                        },
                        extrudePosteriorTeeth: {
                            value: false,
                            upper: false,
                            lower: false,
                        },
                        placeMiniImplantsTAD: {
                            value: false,
                            input: '',
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_DEEP_BITE_IMPROVE: {
            return {
                ...state,
                deepBite1: {
                    ...state.deepBite1,
                    subValue: {
                        ...initialState.deepBite1.subValue,
                        value: action.value,
                    },
                },
            };
        }
        case actionTypes.NEW_PATIENT_PRES_DEEP_BITE_CHECKBOX: {
            if (action.category) {
                return {
                    ...state,
                    deepBite1: {
                        ...state.deepBite1,
                        subValue: {
                            ...state.deepBite1.subValue,
                            value: null,
                            [action.category]: {
                                ...state.deepBite1.subValue[action.category],
                                [action.field]: !state.deepBite1.subValue[action.category][action.field],
                            },
                        },
                    },
                };
            } else if (!state.deepBite1.subValue[action.field].value) {
                return {
                    ...state,
                    deepBite1: {
                        ...state.deepBite1,
                        subValue: {
                            ...state.deepBite1.subValue,
                            value: null,
                            [action.field]: {
                                ...state.deepBite1.subValue[action.field],
                                value: !state.deepBite1.subValue[action.field].value,
                            },
                        },
                    },
                };
            } else {
                let copy = JSON.parse(JSON.stringify({ ...state.deepBite1.subValue }));
                copy[action.field].value = false;
                if (
                    !copy.extrudePosteriorTeeth.value &&
                    !copy.intrudeAnteriorTeeth.value &&
                    !copy.placeMiniImplantsTAD.value
                ) {
                    return {
                        ...state,
                        deepBite1: {
                            ...state.deepBite1,
                            subValue: {
                                value: 'noPreference',
                                extrudePosteriorTeeth: {
                                    lower: false,
                                    upper: false,
                                    value: false,
                                },
                                intrudeAnteriorTeeth: {
                                    lower: false,
                                    upper: false,
                                    value: false,
                                },
                                placeMiniImplantsTAD: {
                                    input: '',
                                    value: false,
                                },
                            },
                        },
                    };
                }
                return {
                    ...state,
                    deepBite1: {
                        ...state.deepBite1,
                        subValue: {
                            ...state.deepBite1.subValue,
                            value: null,
                            [action.field]: {
                                ...initialState.deepBite1.subValue[action.field],
                                value: !state.deepBite1.subValue[action.field].value,
                            },
                        },
                    },
                };
            }
        }
        case actionTypes.NEW_PATIENT_PRES_DEEP_BITE_TEXT:
            return {
                ...state,
                deepBite1: {
                    ...state.deepBite1,
                    subValue: {
                        ...state.deepBite1.subValue,
                        placeMiniImplantsTAD: {
                            ...state.deepBite1.subValue.placeMiniImplantsTAD,
                            input: action.value,
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_MIDLINE:
            if (action.value === 'maintainInitialMidline') {
                return {
                    ...state,
                    midline1: initialState.midline1,
                };
            }
            return {
                ...state,
                midline1: {
                    value: 'improveResultingMidlineBy',
                    subValue: {
                        value: 'noPreference',
                        upper: {
                            checked: false,
                            value: null,
                        },
                        lower: {
                            checked: false,
                            value: null,
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_MIDLINE_IMPROVE: {
            if (!action.field) {
                return {
                    ...state,
                    midline1: {
                        ...state.midline1,
                        subValue: {
                            ...initialState.midline1.subValue,
                            value: action.value,
                        },
                    },
                };
            } else if (!state.midline1.subValue[action.field].checked) {
                return {
                    ...state,
                    midline1: {
                        ...state.midline1,
                        subValue: {
                            ...state.midline1.subValue,
                            value: null,
                            [action.field]: {
                                ...state.midline1.subValue[action.field],
                                checked: !state.midline1.subValue[action.field].checked,
                            },
                        },
                    },
                };
            } else {
                const copy = JSON.parse(JSON.stringify({ ...state.midline1 }));
                copy.subValue[action.field].checked = false;
                if (!copy.subValue.upper.checked && !copy.subValue.lower.checked) {
                    return {
                        ...state,
                        midline1: {
                            ...state.midline1,
                            subValue: {
                                ...state.midline1.subValue,
                                value: 'noPreference',
                                upper: {
                                    checked: false,
                                    value: null,
                                },
                                lower: {
                                    checked: false,
                                    value: null,
                                },
                            },
                        },
                    };
                }
                return {
                    ...state,
                    midline1: {
                        ...state.midline1,
                        subValue: {
                            ...state.midline1.subValue,
                            value: null,
                            [action.field]: {
                                ...initialState.midline1.subValue[action.field],
                                checked: !state.midline1.subValue[action.field].checked,
                            },
                        },
                    },
                };
            }
        }
        case actionTypes.NEW_PATIENT_PRES_MIDLINE_POSITION: {
            return {
                ...state,
                midline1: {
                    ...state.midline1,
                    subValue: {
                        ...state.midline1.subValue,
                        [action.field]: {
                            ...state.midline1.subValue[action.field],
                            value: action.value,
                        },
                    },
                },
            };
        }
        case actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE:
            if (action.value === 'maintainInitialCrossbite') {
                return {
                    ...state,
                    posteriorCrossbite1: initialState.posteriorCrossbite1,
                };
            }
            return {
                ...state,
                posteriorCrossbite1: {
                    value: 'correct',
                    subValue: {
                        value: 'noPreferenceShowResultsInSimulator',
                        subValue: {
                            value: null,
                            buttonPressedDirectlyOnAligner: {
                                maxillaryTeeth: false,
                                mandibularTeeth: false,
                            },
                            cutoutToBondButtonDirectlyOnTeeth: {
                                maxillaryTeeth: false,
                                mandibularTeeth: false,
                            },
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_CORRECT: {
            if (action.field) {
                return {
                    ...state,
                    posteriorCrossbite1: {
                        ...state.posteriorCrossbite1,
                        subValue: {
                            ...state.posteriorCrossbite1.subValue,
                            subValue: {
                                ...initialState.posteriorCrossbite1.subValue.subValue,
                                value: action.value,
                            },
                        },
                    },
                };
            } else if (action.value === 'interarchElastics') {
                return {
                    ...state,
                    posteriorCrossbite1: {
                        ...state.posteriorCrossbite1,
                        subValue: {
                            value: 'interarchElastics',
                            subValue: {
                                value: 'cutoutToBondButtonDirectlyOnTeeth',
                                buttonPressedDirectlyOnAligner: {
                                    maxillaryTeeth: false,
                                    mandibularTeeth: false,
                                },
                                cutoutToBondButtonDirectlyOnTeeth: {
                                    maxillaryTeeth: false,
                                    mandibularTeeth: false,
                                },
                            },
                        },
                    },
                };
            } else {
                return {
                    ...state,
                    posteriorCrossbite1: {
                        ...state.posteriorCrossbite1,
                        subValue: {
                            ...initialState.posteriorCrossbite1.subValue,
                            value: action.value,
                        },
                    },
                };
            }
        }
        case actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_TEETH: {
            return {
                ...state,
                posteriorCrossbite1: {
                    ...state.posteriorCrossbite1,
                    subValue: {
                        ...state.posteriorCrossbite1.subValue,
                        subValue: {
                            ...state.posteriorCrossbite1.subValue.subValue,
                            [action.category]: {
                                ...state.posteriorCrossbite1.subValue.subValue[action.category],
                                [action.field]:
                                    !state.posteriorCrossbite1.subValue.subValue[action.category][action.field],
                            },
                        },
                    },
                },
            };
        }
        case actionTypes.NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_OTHER: {
            const newState = JSON.parse(JSON.stringify({ ...state }));
            newState.posteriorCrossbite1.subValue.subValue.otherMethod = action.value;
            return newState;
        }
        case actionTypes.NEW_PATIENT_PRES_CUTTING_OPTIONS:
            return {
                ...state,
                cuttingOptions1: action.value,
            };
        case actionTypes.NEW_PATIENT_PRES_AUXILIARIES: {
            if (Object.hasOwn(state.auxiliaries1, action.field)) {
                if (
                    action.value === 'No' &&
                    (state.auxiliaries1.classIIElastics === 'No' || state.auxiliaries1.classIIIElastics === 'No')
                ) {
                    return {
                        ...state,
                        auxiliaries1: {
                            ...state.auxiliaries1,
                            [action.field]: action.value,
                            subValue: initialState.auxiliaries1.subValue,
                        },
                    };
                }
                return {
                    ...state,
                    auxiliaries1: {
                        ...state.auxiliaries1,
                        [action.field]: action.value,
                        subValue: {
                            upper: {
                                value: 'upperCutout',
                            },
                            lower: {
                                value: 'lowerCutout',
                            },
                        },
                    },
                };
            } else {
                return {
                    ...state,
                    auxiliaries1: {
                        ...state.auxiliaries1,
                        subValue: {
                            ...state.auxiliaries1.subValue,
                            [action.category]: {
                                value: action.value,
                            },
                        },
                    },
                };
            }
        }
        case actionTypes.NEW_PATIENT_PRES_AUXILIARIES_OTHER_ELASTICS:
            if (action.field === 'otherElastics') {
                return {
                    ...state,
                    auxiliaries1: {
                        ...state.auxiliaries1,
                        otherElastics: {
                            ...state.auxiliaries1.otherElastics,
                            comment: action.value,
                        },
                    },
                };
            }
            return {
                ...state,
                auxiliaries1: {
                    ...state.auxiliaries1,
                    otherElastics: {
                        value: action.value,
                        comment: '',
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PRES_TRIODIM_FORCE:
            return {
                ...state,
                trioDimForce: action.value,
            };
        case actionTypes.NEW_PATIENT_PRES_SPECIAL_INSTRUCTIONS:
            return {
                ...state,
                specialInstructions1: action.value,
            };
        case actionTypes.NEW_PATIENT_PRES_ERROR:
            if (!action.error) {
                return {
                    ...state,
                    prescriptionError: '',
                };
            }

            return {
                ...state,
                prescriptionError: action.error,
            };
        case actionTypes.NEW_PATIENT_PRES_ERROR_QUESTION:
            return {
                ...state,
                prescriptionErrorQuestion: action.value,
            };
        case actionTypes.NEW_PATIENT_PRES_ERROR_SCROLL_ID:
            console.log('action.value => ', action.value);
            return {
                ...state,
                prescriptionScrollToId: action.value,
            };
        case actionTypes.NEW_PATIENT_PRES_ERROR_SCROLL:
            return {
                ...state,
                prescriptionScroll: !state.prescriptionScroll,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_GENDER:
            return {
                ...state,
                gender: initialState.gender,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_LASTNAME:
            return {
                ...state,
                lastName: initialState.lastName,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_FIRSTNAME:
            return {
                ...state,
                firstName: initialState.firstName,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_DAY:
            return {
                ...state,
                day: initialState.day,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_MONTH:
            return {
                ...state,
                month: initialState.month,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_YEAR:
            return {
                ...state,
                year: initialState.year,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_REFERENCE_CODE:
            return {
                ...state,
                refCode: initialState.refCode,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_REMARK:
            return {
                ...state,
                remarks: initialState.remarks,
            };
        case actionTypes.NEW_PATIENT_RESET_INTERNAL_REMARK:
            return {
                ...state,
                internalRemarks: initialState.internalRemarks,
            };
        case actionTypes.NEW_PATIENT_RESET_DR_REMARK:
            return {
                ...state,
                dr_remark: initialState.dr_remark,
            };
        case actionTypes.NEW_PATIENT_INFO_RESET_PHOTO:
            return {
                ...state,
                patientPhoto: initialState.patientPhoto,
            };
        case actionTypes.NEW_PATIENT_RESET_RETAINER_REQUEST:
            const clone = {
                retainer_request_id: state.retainerRequestPrescriptionNote?.retainer_request_id,
            };
            return {
                ...state,
                retainerRequestPrescriptionNote: { ...clone },
                // retainerRequestPrescriptionNote : initRetainerReqFormValue
            };
        case actionTypes.NEW_PATIENT_RFS_USE_FILES:
            let files = state.files.map((imageObj) => {
                if (Object.keys(action.value).includes(ray_photo_mapping[imageObj.id])) {
                    let path = action.value[ray_photo_mapping[imageObj.id]];
                    imageObj['data'] = path;
                    imageObj['dataURL'] = path;
                    imageObj['uploaded'] = true;
                }
                return imageObj;
            });
            return {
                ...state,
                files,
            };
        case actionTypes.NEW_PATIENT_SET_RETAINER_REQUEST:
            return {
                ...state,
                retainerRequestPrescriptionNote: action.payload,
            };
        case actionTypes.NEW_PATIENT_RESTORATIVE_OPTIONS:
            return {
                ...state,
                restorativeOptions: {
                    ...state.restorativeOptions,
                    value: action.value,
                    subValue: {
                        ...initialState.restorativeOptions.subValue,
                        value: action.value === 'Yes' ? 'flowableInjection' : '',
                    },
                },
            };
        case actionTypes.NEW_PATIENT_RESTORATIVE_OPTIONS_SUB_VALUE:
            console.log('action => ', action);
            return {
                ...state,
                restorativeOptions: {
                    ...state.restorativeOptions,
                    subValue: {
                        ...state.restorativeOptions.subValue,
                        [action.field]: action.value,
                    },
                },
            };
        case actionTypes.NEW_PATIENT_RESTORATIVE_OPTIONS_ONLAY:
            console.log('action => ', action);
            let clonedOnlayPosition = handleListUpdate(
                [...state.restorativeOptions.subValue.onlayPosition],
                action.value
            );
            return {
                ...state,
                restorativeOptions: {
                    ...state.restorativeOptions,
                    subValue: {
                        ...state.restorativeOptions.subValue,
                        onlayPosition: [...clonedOnlayPosition],
                    },
                },
            };
        case actionTypes.NEW_PATIENT_RESTORATIVE_OPTIONS_SUB_VALUE_VERTICAL_DIMENSION:
            console.log('action => ', action);
            return {
                ...state,
                restorativeOptions: {
                    ...state.restorativeOptions,
                    subValue: {
                        ...state.restorativeOptions.subValue,
                        verticalDimension: {
                            ...state.restorativeOptions.subValue.verticalDimension,
                            [action.field]: action.value,
                        },
                    },
                },
            };
        case actionTypes.NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION:
            console.log('action => ', action);
            let list = [...state.preImplantAligment.prostheticSpace];
            if (action.value === 'No') {
                list = [];
            }
            return {
                ...state,
                preImplantAligment: {
                    value: action.value,
                    prostheticSpace: list,
                },
            };
        case actionTypes.NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION_PROSTHETIC_SPACE:
            let prostheticSpace = handleListUpdate([...state.preImplantAligment.prostheticSpace], action.value);
            return {
                ...state,
                preImplantAligment: {
                    ...state.preImplantAligment,
                    prostheticSpace: [...prostheticSpace],
                },
            };
        case actionTypes.NEW_PATIENT_ADD_ON_SMILE_DESIGN:
            return {
                ...state,
                addOnSmileDesign: {
                    ...state.addOnSmileDesign,
                    value: action.value,
                },
            };
        case actionTypes.NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_IS_VALID:
            console.log('action.value => ', action.value);
            console.log('type of action.value => ', typeof action.value);
            let errList = [...state.errors];
            let smileDesignErr = buildSmileDesignPrescriptionErr(
                action.value,
                () => Base_Smile_Design_Prescription_Err.msg
            );
            const errIndex = errList.findIndex((e) => e.id === Base_Smile_Design_Prescription_Err.id);
            if (errIndex === -1) {
                errList.push(smileDesignErr);
            } else {
                errList[errIndex] = smileDesignErr;
            }
            return {
                ...state,
                upSellSmileDesignPrescriptionFormIsValid: action.value,
                errors: [...errList],
            };
        case actionTypes.NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_DATA:
            return {
                ...state,
                upSellSmileDesignPrescriptionFormData: { ...action.value },
            };
        case actionTypes.NEW_PATIENT_SET_VISITED_TABS:
            return {
                ...state,
                visitedTabs: [...new Set([...state.visitedTabs, action.value])],
            };
        case actionTypes.NEW_PATIENT_RESTORATIVE_OPTIONS_POSTERIOR:
            let listValue = Array.isArray(action.value) ? action.value : [];
            return {
                ...state,
                restorativeOptions: {
                    ...state.restorativeOptions,
                    subValue: {
                        ...state.restorativeOptions.subValue,
                        onlayPosition: [...listValue],
                    },
                },
            };
    }
    return state;
};

export default reducer;

const handleListUpdate = (list = [], value) => {
    let clone = [...list];
    if (clone.includes(value)) {
        clone = clone.filter((v) => v !== value);
    } else {
        clone = [...clone, value];
    }
    return clone;
};
